// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import trpEntity from './entities/trp.json';
import trpMenu from '../pages/trp/menu.json';
import trpFullForm from '../pages/trp/forms/full.json';
import trpContextForm from '../pages/trp/forms/context.json';
import trpMiniForm from '../pages/trp/forms/mini.json';
import trpLookupForm from '../pages/trp/forms/lookup.json';
import trpTableView from '../pages/trp/views/table.json';
import trpStagesView from '../pages/trp/views/stages.json';
import trpCardsView from '../pages/trp/views/cards.json';
import trpInlineView from '../pages/trp/views/inline.json';
import trpBacklogView from '../pages/trp/views/backlog.json';
import trpSplitView from '../pages/trp/views/split.json';
import trpCalendarView from '../pages/trp/views/calendar.json';
import trpDashboardView from '../pages/trp/views/dashboard.json';

/** Тип запису «Звіт» зі сторінками пакета: меню, форми та подання з pages/trp/. */
export const trpDefinition: IRecordTypeDefinition = {
  ...trpEntity,
  views: assembleViewSet({
      table: trpTableView,
      stages: trpStagesView,
      cards: trpCardsView,
      inline: trpInlineView,
      backlog: trpBacklogView,
      split: trpSplitView,
      calendar: trpCalendarView,
      dashboard: trpDashboardView,
  }),
  form: trpFullForm,
  forms: { full: trpFullForm, context: trpContextForm, mini: trpMiniForm, lookup: trpLookupForm },
  menu: trpMenu,
} as IRecordTypeDefinition;
